import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageShell from "../dashboard/PageShell";
import {
  ForeignStaffBasicInfo,
  ForeignStaffContactInfo,
  ForeignStaffFileUpload,
  ForeignStaffFormActions,
} from "../../components/forms/ForeignStaffForm";

interface EditForeignStaffProps {}

const EditForeignStaff: React.FC<EditForeignStaffProps> = () => {
  const navigate = useNavigate();

  // Get ID from URL path
  const getForeignStaffId = () => {
    const pathParts = window.location.pathname.split("/");
    return pathParts[pathParts.length - 1];
  };

  const id = getForeignStaffId();

  const [formData, setFormData] = useState({
    fullName: "",
    dateOfBirth: "",
    gender: "",
    phone: "",
    qualification: "",
    academicRank: "",
    degree: "",
    role: "",
    email: "",
    passportNumber: "",
    passportExpiry: "",
    visaExpiry: "",
    entryDate: "",
    temporaryAddress: "",
    nationality: "",
    country: "",
    organization: "",
    notes: "",
    attachedFiles: [] as File[],
  });

  // Mock data for editing - in real app, this would come from API
  const mockForeignStaffData = {
    fullName: "sdsd >>",
    dateOfBirth: "1990-01-01",
    gender: "Nam",
    phone: "98",
    qualification: "Tiến sĩ",
    academicRank: "Giáo sư",
    degree: "PhD",
    role: "Chuyên gia",
    email: "example@email.com",
    passportNumber: "99999999999999999",
    passportExpiry: "2025-09-29",
    visaExpiry: "2025-09-29",
    entryDate: "2025-08-29",
    temporaryAddress: "Hà Nội, Việt Nam",
    nationality: "Trung Quốc",
    country: "Trung Quốc",
    organization: "Đại học Bắc Kinh",
    notes: "Chuyên gia nghiên cứu",
    attachedFiles: [] as File[],
  };

  useEffect(() => {
    // Load foreign staff data for editing
    if (id) {
      // In real app, fetch data from API based on id
      setFormData(mockForeignStaffData);
    }
  }, [id]);

  const handleInputChange = (field: string, value: string | File[]) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    console.log("Updating foreign staff data:", formData);
    // TODO: Implement update functionality
    // After successful update, navigate back to foreign staff list
    navigate("/foreign-staff");
  };

  const handleCancel = () => {
    window.history.back();
  };

  return (
    <PageShell title="Sửa Cán bộ nước ngoài">
      <div className="space-y-4">
        {/* Header Section */}
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">
            Sửa Cán bộ nước ngoài
          </h1>
        </div>

        {/* Form Section */}
        <div className="bg-white rounded-lg p-4">
          <div className="space-y-4">
            <ForeignStaffBasicInfo
              formData={formData}
              handleInputChange={handleInputChange}
            />

            <ForeignStaffContactInfo
              formData={formData}
              handleInputChange={handleInputChange}
            />

            <ForeignStaffFileUpload
              formData={formData}
              handleInputChange={handleInputChange}
            />
          </div>
        </div>

        <ForeignStaffFormActions onSave={handleSave} onCancel={handleCancel} />
      </div>
    </PageShell>
  );
};

export default EditForeignStaff;
